import * as React from "react";
import { TextArea, Form, Confirm } from "semantic-ui-react";

interface Props {
    isOpen: boolean;
    caseId: string;
    onConfirm: (reason: string) => void;
    onClose: () => void;
}

export const ConfidentialityChangeConfirmModal: React.FunctionComponent<Props> = (props: Props) => {
    const [reason, setReason] = React.useState<string>("");
    const [reasonError, setReasonError] = React.useState(false);
    const close = () => {
        setReason("");
        setReasonError(false);
        props.onClose();
    };

    const confirm = () => {
        if (reason) {
            props.onConfirm(reason);
            close();
        } else {
            setReasonError(true);
        }
    };

    const content = (<>
        <div>You are about to change the case {props.caseId} confidentiality. Are you sure you wish to continue?</div>
        <br />
        <Form>
            <Form.Field
                error={reasonError && !reason && "You must provide a reason"}
                control={TextArea}
                label='Reason'
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setReason(e.target.value)}
                value={reason}
            />
        </Form>
    </>);
    return (
        <Confirm
            open={props.isOpen}
            header="Case Confidentiality"
            content={{ content }}
            onCancel={close}
            onConfirm={confirm}
            size="large"
            confirmButton={{ children: "Confirm" }}
        />
    );
};
